(() => {
  const CLOSED_MID_Y = 8;   // Λ
  const OPEN_MID_Y = 20;    // V
  const EDGE_Y = 14;        // fixed left/right y
  const ANIM_MS = 240;

  class GDD {
    constructor(root) {
      this.root = root;
      this.trigger = root.querySelector('.gdd__trigger');
      this.label = root.querySelector('.gdd__label');
      this.panel = root.querySelector('.gdd__panel');
      this.native = root.querySelector('.gdd__native');
      this.chevronLine = root.querySelector('.gdd__chevron-line');
      this.options = [...root.querySelectorAll('.gdd__option')];
      this.raf = null;
      this.chevronY = CLOSED_MID_Y;

      if (!this.trigger || !this.panel || !this.native) return;

      this.setChevronY(CLOSED_MID_Y); // closed => up
      this.bind();
    }

    bind() {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = this.root.classList.toggle('is-open');
        this.trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        this.animateChevron(isOpen);
      });

      this.options.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;

          const value = btn.dataset.value;
          this.native.value = value;
          this.native.dispatchEvent(new Event('change', { bubbles: true }));

          if (this.label) this.label.textContent = btn.textContent.trim();

          this.options.forEach((o) => {
            o.classList.remove('is-selected');
            o.setAttribute('aria-selected', 'false');
          });

          btn.classList.add('is-selected');
          btn.setAttribute('aria-selected', 'true');

          this.close();
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.root.contains(e.target)) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    setChevronY(y) {
      if (!this.chevronLine) return;
      this.chevronY = y;
      this.chevronLine.setAttribute('points', `6,${EDGE_Y} 12,${y} 18,${EDGE_Y}`);
    }

    animateChevron(isOpen) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const targetY = isOpen ? OPEN_MID_Y : CLOSED_MID_Y;

      if (reduceMotion || !this.chevronLine) {
        this.setChevronY(targetY);
        return;
      }

      if (this.raf) cancelAnimationFrame(this.raf);

      const fromY = this.chevronY;
      const toY = targetY;
      const start = performance.now();

      const easeInOutCubic = (t) =>
        t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

      const tick = (now) => {
        const t = Math.min(1, (now - start) / ANIM_MS);
        const e = easeInOutCubic(t);
        const y = fromY + (toY - fromY) * e;
        this.setChevronY(y);

        if (t < 1) {
          this.raf = requestAnimationFrame(tick);
        } else {
          this.raf = null;
          this.setChevronY(toY);
        }
      };

      this.raf = requestAnimationFrame(tick);
    }

    close() {
      this.root.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.animateChevron(false); // closed => Λ
    }
  }

  const init = () => {
    document.querySelectorAll('[data-global-dropdown]').forEach((el) => {
      if (!el.dataset.gddInit) {
        new GDD(el);
        el.dataset.gddInit = '1';
      }
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
